import { Chip } from "@mui/material"

const STATUS_CONFIG = {
    pending: { label: "Pending", sx: { bgcolor: "rgba(0,0,0,0.06)", color: "text.primary" } },
    processing: { label: "Processing…", sx: { bgcolor: "rgba(26,140,180,0.12)", color: "text.primary" } },
    complete: { label: "Ready", sx: { bgcolor: "rgba(0,171,85,0.14)", color: "text.primary" } },
    error: { label: "Error", sx: { bgcolor: "rgba(255,72,66,0.12)", color: "text.primary" } },
    applied: { label: "Applied", sx: { bgcolor: "rgba(156,39,176,0.12)", color: "text.primary" } },
}

export function ResolutionStatusChip({ status }) {
    const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.pending
    return <Chip label={config.label} size="small" sx={config.sx} />
}
